import React from 'react';
import { ArrowRight, History } from 'lucide-react';
import { format } from 'date-fns';

const PettyCashAllocationHistory = ({ history }) => {
    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/50 flex items-center gap-2">
                <History size={18} className="text-sm-primary" />
                <h2 className="text-lg font-semibold text-gray-900">Allocation History</h2>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-left">
                    <thead>
                        <tr className="text-xs font-bold text-gray-400 uppercase tracking-wider border-b border-gray-100">
                            <th className="py-3 px-6">Flow</th>
                            <th className="py-3 px-6 text-center">Amount</th>
                            <th className="py-3 px-6 text-right">Date</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {history?.length > 0 ? (
                            history.map((item, index) => (
                                <tr key={index} className="hover:bg-gray-50 transition-colors">
                                    <td className="py-4 px-6">
                                        <div className="flex items-center gap-3">
                                            <div className="flex flex-col">
                                                <span className="text-sm font-semibold text-gray-900">{item.from_employee}</span>
                                                <span className="text-xs text-gray-400 uppercase">From</span>
                                            </div>
                                            <ArrowRight size={16} className="text-sm-accent mx-2" />
                                            <div className="flex flex-col">
                                                <span className="text-sm font-semibold text-gray-900">{item.to_employee}</span>
                                                <span className="text-xs text-gray-400 uppercase">To</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="py-4 px-6 text-center">
                                        <span className="inline-flex items-center px-3 py-1 rounded-lg bg-purple-50 text-sm-primary font-bold">
                                            ₹{item.amount?.toLocaleString()}
                                        </span>
                                    </td>
                                    <td className="py-4 px-6 text-right text-sm text-gray-500">
                                        {item.date ? format(new Date(item.date), 'MMM d, yyyy') : '-'}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="py-12 text-center text-gray-500 italic">
                                    No allocation history found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PettyCashAllocationHistory;
